// @flow

export const LOAD_SCREENING_PARAMS: 'screening-params/load' =
  'screening-params/load';

export type Action = {
  type: typeof LOAD_SCREENING_PARAMS,
  name: string,
  screeningParams: []
};
